import { StringModule } from "../../core/StringModule";
import { StringObject } from "../../objects/StringObject";

export class StringInview extends StringModule {
  constructor(visitor: any) {
    super(visitor);
    this.htmlKey = '';
  }
  canConnect(object: StringObject): boolean {
    return object.keys[0] == undefined || object.getProperty<boolean>("inview-fallback") === true;
  }
}
